// eslint-disable-next-line import/prefer-default-export
export const INTERFACE_CODE = "interface_omb";
export const defaultLanguage = "pl";
export const secondaryLanguage = "en";
